import {Row, Col, message} from 'antd';
import { useHistory } from 'react-router-dom';
import KnowledgeCard from '../KnowledgeCard';
import BaseTitle from '../BaseTitle';
import EmptyData from '../EmptyData';
import s from './index.module.css';
import {useEffect, useState} from "react";
import {getKnowledge} from "../../server/api";

const KnowledgeSection = ({ selectedModule }) => {
  const history = useHistory();
  const [knowledges, setKnowledges] = useState([]);

  useEffect(() => {
    if (selectedModule && selectedModule.code) {
      requestKnowledge();
    }
  }, [selectedModule])

  const requestKnowledge = async () => {
    let params = {
      pageSize: 8,
      pageNo: 1,
      category: selectedModule.code
    };
    getKnowledge(params)
        .then(function (res) {
          const { status, data: { result } } = res;
          if (status === 200) {
            setKnowledges(result.records);
            return;
          }
          message.error('查询数据出错，请刷新重试！');
        })
        .catch(function (error) {
        });
  }

  const knowledgeData = [
    {
      id: 1,
      icon: 'icon-file-text', // 文档图标
      title: '检验检测机构监督管理办法',
      description: '本办法适用于检验检测机构的监督管理，旨在规范检验检测机构的检验检测行为，提高检验检测机构的技术能力和管理水平，维护检验检测市场秩序，保护消费者合法权益。本办法所称检验检测机构，是指依法成立，依据相关标准或者技术规范，利用仪器设备、环境设施等技术条件和专业技能，对产品或者法律法规规定的特定对象进行检验检测的专业技术组织。'
    },
    {
      id: 2,
      icon: 'icon-safety-certificate', // 认证图标
      title: '检验检测机构资质认定管理办法',
      description: '资质认定是指由国家认证认可监督管理委员会或者省级质量技术监督部门依据有关法律法规和标准、技术规范的规定，对检验检测机构的基本条件和技术能力是否符合法定要求实施的评价许可。本办法适用于在中华人民共和国境内从事向社会出具具有证明作用的检验检测数据、结果的检验检测机构的资质认定活动及其监督管理。'
    },
    {
      id: 3,
      icon: 'icon-audit', // 审核图标
      title: '检验检测机构监督管理办法',
      description: '本办法适用于检验检测机构的监督管理，旨在规范检验检测机构的检验检测行为，提高检验检测机构的技术能力和管理水平，维护检验检测市场秩序，保护消费者合法权益。本办法所称检验检测机构，是指依法成立，依据相关标准或者技术规范，利用仪器设备、环境设施等技术条件和专业技能，对产品或者法律法规规定的特定对象进行检验检测的专业技术组织。'
    },
    {
      id: 4,
      icon: 'icon-solution', // 解决方案图标
      title: '检验检测机构资质认定管理办法',
      description: '资质认定是指由国家认证认可监督管理委员会或者省级质量技术监督部门依据有关法律法规和标准、技术规范的规定，对检验检测机构的基本条件和技术能力是否符合法定要求实施的评价许可。本办法适用于在中华人民共和国境内从事向社会出具具有证明作用的检验检测数据、结果的检验检测机构的资质认定活动及其监督管理。'
    }
  ];

  const handleCardClick = (item) => {
    history.push(`/knowledge/${item.id}`);
  };

  const handleViewMore = () => {
    history.push('/knowledge');
  };

  return (
    <div className={s.knowledgeSection}>
      <BaseTitle
          title={selectedModule?.modelTitle2}
          subtitle={selectedModule?.modelDesc2}
      />

      <Row gutter={[24, 24]} className={s.knowledgeCards}>
        {knowledges && knowledges.length > 0 ? (
          knowledges.map((item) => (
            <Col xs={24} sm={12} md={12} lg={6} key={item.id}>
              <KnowledgeCard
                icon={item.icon}
                title={item.title}
                description={item.description}
                publishTime={item.publishTime || item.createTime || item.updateTime}
                views={item.views || item.seeNum || 0}
                onClick={() => handleCardClick(item)}
              />
            </Col>
          ))
        ) : (
          <Col span={24}>
            <EmptyData description="暂无知识数据" />
          </Col>
        )}
      </Row>

      {knowledges && knowledges.length > 0 && (
        <div className={s.knowledgeMore}>
          <a href="#" className={s.moreLink} onClick={(e) => { e.preventDefault(); handleViewMore(); }}>查看更多</a>
        </div>
      )}
    </div>
  );
};

export default KnowledgeSection;
